import { authentication } from "@microsoft/teams-js";
import { DateTime } from "luxon";

import { getTokenExpiryTime } from "../token-utils.js";
import type { AuthService } from "./auth-service.interface.js";

export function createTeamsAuthService(): AuthService {
  return {
    accessToken: null,
    expiresAt: null,

    getName() {
      return "Microsoft Teams";
    },

    async getToken() {
      // Existing token is still valid
      if (
        this.accessToken &&
        this.expiresAt &&
        Date.now() <
          DateTime.fromMillis(this.expiresAt).minus({ minutes: 5 }).toMillis()
      ) {
        return this.accessToken;
      }

      const token = await authentication.getAuthToken();
      const expiresAt = getTokenExpiryTime(token);

      this.accessToken = token;
      this.expiresAt = expiresAt;

      return token;
    },

    async login() {
      // To adhere to the auth-service.interface.js interface
      await Promise.resolve();
    },
  };
}
